// extracted by mini-css-extract-plugin
export var actionText = "_m5-4";
export var container = "_m5-0";
export var leftSection = "_m5-1";
export var rightSection = "_m5-2";
export var settingsButton = "_m5-6";
export var settingsIcon = "_m5-7";
export var shortcut = "_m5-5";
export var shortcutGroup = "_m5-3";